import { Title } from 'src/components'
import AdminClientCrypto from './components/CryptoClient'
import AdminServerCrypto from './components/CryptoServer'

export default function AdminCrypto() {
  return (
    <>
      <Title label="Crypto" className="mb-8" />
      <AdminClientCrypto />
      <div className="mb-4" />
      <AdminServerCrypto />
    </>
  )
}
